<template>

  <div class="array-content">
    <div class="array-toolbar">

      <div class="modal-toolbar-buttons">
        <button class="btn btn-sm btn-outline-success" id="btn-select-all"
                @click="field.value.forEach(x=>x.select=true)" style="">✓
          Выбрать все
        </button>
        <button class="btn btn-sm btn-outline-dark" id="btn-deselect-all"
                @click="field.value.forEach(x=>x.select=false)" style="">✗
          Снять все
        </button>
        <button class="btn btn-sm btn-outline-secondary" id="btn-show-hidden" @click="show_hidden=!show_hidden">Показать
          скрытые
          ({{ field.value.filter(x => x.hide).length }})
        </button>
      </div>
    </div>
    <div class="modal-body">
      <table class="modal-table">
        <thead id="modal-thead">
        <tr>
          <th width="30"></th>
          <th v-for="f in field.fields">{{ f }}</th>
          <th v-if="!field.fields">Значение</th>
          <th width="60"></th>
        </tr>
        </thead>
        <tbody id="modal-tbody">
        <template v-if="field.fields">
          <tr v-for="values in field.value" v-show="!values.hide || show_hidden">

            <td><input type="checkbox" v-model="values.select"></td>
            <td v-for="val in values.value">
              <template v-if="isFlag(val)">
                      <span v-for="flag in isFlag(val)" class="badge"
                            :style="{backgroundColor: flag.color + '20', color: flag.color, borderColor: flag.color}">{{
                          flag.name
                        }}</span>
              </template>
              <template v-else>{{ val }}</template>
            </td>
            <td>
              <button v-if="!values.hide" class="btn-hide" @click="values.hide=!values.hide" title="Скрыть">👁</button>
              <button v-else class="btn-hide" @click="values.hide=!values.hide" title="Вернуть">↩</button>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="value in field.value" v-show="!value.hide || show_hidden">

            <td><input type="checkbox" v-model="value.select"></td>
            <td>
              <template v-if="isUrl(value.value)">
                <a :href="value.value" target="_blank">{{ value.value }}</a>
              </template>
              <template v-else>{{ value.value }}</template>
            </td>
            <td>
              <button v-if="!value.hide" class="btn-hide" @click="value.hide=!value.hide" title="Скрыть">👁</button>
              <button v-else class="btn-hide" @click="value.hide=!value.hide" title="Вернуть">↩</button>
            </td>
          </tr>
        </template>

        </tbody>
      </table>
    </div>
  </div>


</template>

<script>


export default {
  name: 'PdfArray',
  props: {
    field: {type: Object},
  },
  data() {
    return {
      show_hidden: false
    }
  },
  mounted: function () {

  },
  methods: {
    isUrl(str) {
      try {
        new URL(str);
        return true;
      } catch {
        return false;
      }
    },
    isFlag(val) {
      if (Array.isArray(val)) return val
      try {
        if (Array.isArray(JSON.parse(val))) return JSON.parse(val)
      } catch (e) {
        return false
      }
    }
  }
}

</script>

<style scoped lang="scss">


.array-content {
  display: flex;
  flex-direction: column;
  width: 800px;


  .array-toolbar {
    padding: 12px 20px;
    background: #f8f9fa;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
  }
}


.modal-search {
  flex: 1;
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
}

.modal-toolbar-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  min-height: 200px;
  max-height: 400px;
}

.modal-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.modal-table th, .modal-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.modal-table th {
  background: #f8f9fa;
  position: sticky;
  top: 0;
  font-weight: 600;
  z-index: 5;
}

.modal-table tr:hover {
  background: #f8fbff;
}

.modal-table tr.hidden-row {
  background: #fff8e1;
}

td {
  word-break: break-all;
  overflow-wrap: break-word;
}

.btn-hide {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #999;
}

.btn-hide:hover {
  color: #e74c3c;
}

</style>
